import {Chip} from '@mui/material';
import {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import useFertility from '../../hooks/useFertility';
import {reset} from '../../Redux/Slice/fertilitySlice';
import '../../styles/Patients.scss';
import {formatDate} from '../../utils/dateTime';
import Actions from './Actions';
import FertilityTable from './FertilityTable';
import Filters from './Filters';
import PageHeader from './PageHeader';

const Fertility = ({loaderchange, popupalert, popuptext}) => {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({search: ''});
  const [pagination, setPagination] = useState({pageIndex: 1, pageSize: 10});

  const {tableData, dataCount} = useFertility(filters, pagination, loaderchange, popupalert, popuptext);

  const sideactive = useSelector(state => state.counter.sidebarnav);

  useEffect(() => {
    // Reset fertility state when landing directly on the fertility list page
    dispatch(reset());
  }, []);
  const columns = useMemo(
    () => [
      {Header: 'Patient Name', accessor: 'patient_name'},
      {
        Header: 'Treatment Type',
        accessor: 'treatment_type'
      },
      {
        Header: ' Cycle Number',
        accessor: 'cycle'
      },
      {
        Header: 'Beta-hCG',
        accessor: 'beta_hcg_test_date',
        Cell: ({value}) => {
          const formattedDate = formatDate(value);
          return (
            <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={formattedDate}>
              {formattedDate}
            </div>
          );
        }
      },
      {
        Header: 'Result',
        accessor: 'result',
        Cell: ({value}) => {
          const getStatusColor = result => {
            switch (result) {
              case 'Pending':
                return 'warning';
              case 'Positive':
                return 'success';
              case 'Negative':
                return 'error';
              default:
                return 'default';
            }
          };
          return (
            <Chip
              label={value}
              color={getStatusColor(value)}
              // variant="outlined"
              size='small'
              sx={{
                height: '20px', // Reduce overall height
                padding: '0 6px', // Adjust padding
                '& .MuiChip-label': {
                  fontSize: '0.75rem', // Reduce text size
                  padding: '0 4px' // Adjust inner padding
                }
              }}
            />
          );
        }
      },
      {Header: 'Remarks', accessor: 'remarks'},
      {
        Header: 'Actions',
        accessor: 'id',
        Cell: ({row}) => {
          if (!row.original || Object.keys(row.original).length === 0) {
            return <span>No Data</span>;
          }
          return <Actions data={row.original} loaderchange={loaderchange} />;
        }
      }
    ],
    []
  );

  return (
    <div className={sideactive ? 'maincontainer-patient-sa' : 'maincontainer-patient'}>
      <PageHeader title='Fertility' tableData={tableData} type='fertility' />
      <div className='row mt-4'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='patient'>
                <div className='table-content-patient'>
                  <Filters filters={filters} setFilters={setFilters} setPagination={setPagination} pageType='fertility' />
                  <FertilityTable data={tableData} columns={columns} pagination={pagination} setPagination={setPagination} datacount={dataCount} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fertility;
